import { useEffect } from "react";
import Lenis from "lenis";
import { useI18n } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Approach } from "@/components/site/Approach";
import { Expertise } from "@/components/site/Expertise";
import { Projects } from "@/components/site/Projects";
import { Profile } from "@/components/site/Profile";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const { lang } = useI18n();

  useEffect(() => {
    const link = document.querySelector('link[rel="canonical"]');
    if (link) link.href = lang === "en" ? "https://bardinepa.ch/en/" : "https://bardinepa.ch/";
  }, [lang]);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (!/^#[A-Za-z][\w-]*$/.test(id)) return; // only same-page section anchors
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -10 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <main className="relative min-h-screen bg-[#f4f4f0]">
      <Navbar />
      <Hero />
      <Marquee />
      <Approach />
      <Expertise />
      <Projects />
      <Profile />
      <Contact />
      <Footer />
      <Toaster position="bottom-right" />
    </main>
  );
}
